import idle from './svg/owl-idle.svg?raw';
import done from './svg/owl-done.svg?raw';
import think from './svg/owl-think.svg?raw';
import hero from './svg/owl.svg?raw';

const SVG = { idle, done, think, hero } as const;
export type OwlKind = keyof typeof SVG;

/** Chú cú Ask HANA (SVG lấy nguyên từ board Mint-AskHana, giữ màu gốc trong file .svg): idle · done (có tia sáng) · think · hero. */
export function Owl({ kind, size }: { kind: OwlKind; size: number }) {
  return (
    <span aria-hidden="true" style={{ width: size, height: size, display: 'flex', flexShrink: 0 }} dangerouslySetInnerHTML={{ __html: SVG[kind] }} />
  );
}
